import { render, staticRenderFns } from "./DispatchStepper.vue?vue&type=template&id=8260fda0&scoped=true"
import script from "./DispatchStepper.vue?vue&type=script&lang=js"
export * from "./DispatchStepper.vue?vue&type=script&lang=js"
import style0 from "./DispatchStepper.vue?vue&type=style&index=0&id=8260fda0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8260fda0",
  null
  
)

export default component.exports